import { Telefone } from "./components/telefone";

import desligarIcon from "../../../../../assets/icons/desligar.svg";
import callIcon from "../../../../../assets/icons/ligar.svg";

import { PauseIcon } from "../../../../../assets/svg/pause";
import { MuteIcon } from "../../../../../assets/svg/mute";
import { Transfer } from "../../../../../assets/svg/transfer";
import { KeyBoardIcon } from "../../../../../assets/svg/keyboard";

export const Ligacao = () => {
  const color = "#103680";
  return (
    <div className="w-full -mt-24  overflow-y-auto">
      <div className="flex w-full max-w-xl flex-col items-center text-xs lg:text-sm ">
        <div className="flex h-14  w-full items-center justify-between rounded-md  bg-gray-300 p-4">
          <button className="rounded-full bg-white p-2 ">
            <PauseIcon color={color} />
          </button>
          <button className="rounded-full bg-white p-2">
            <MuteIcon color={color} />
          </button>
          <button className="rounded-full bg-white p-2">
            <Transfer color={color} />
          </button>
          <button className="rounded-full bg-white p-2">
            <KeyBoardIcon color={color} />
          </button>
        </div>

        <Telefone />

        <div className="my-4 flex w-[80%] items-center justify-between px-10">
          <button className="rounded-full bg-green-600 p-4">
            <img src={callIcon} alt="" className="h-6 w-6" />
          </button>
          <button className="rounded-full bg-red-700 p-3">
            <img src={desligarIcon} alt="" className="h-8 w-8" />
          </button>
        </div>
      </div>
    </div>
  );
};
